import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { VersionCheckHelper } from "./helper/version-check.helper";
import { AuthService } from "./services/auth.service";

@Component({
  selector: "app-root",
  templateUrl: "./app-main.html",
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppMain implements OnInit {
  isLoading = signal(true);
  title: string = "asah skill";
  checkVersion = inject(VersionCheckHelper);
  auth = inject(AuthService);

  async ngOnInit() {
    this.isLoading.set(true);

    // Suppress harmless Finpay checkout popup errors
    const originalConsoleError = console.error;
    console.error = (...args: any[]) => {
      const errorMsg = args[0]?.toString() || "";
      if (errorMsg.includes("No checkout popup config found")) {
        // Silently ignore Finpay SDK initialization errors
        return;
      }
      originalConsoleError.apply(console, args);
    };

    try {
      // Run version check and auth validation in parallel
      await Promise.all([
        this.checkVersion
          .initVersionCheck("/assets/version.json")
          .catch((err) => {
            console.warn("Version check skipped:", err);
          }),
        this.waitForAuth(),
      ]);
    } catch (err) {
      console.warn("Initialization error:", err);
    } finally {
      this.isLoading.set(false);
    }
  }

  /**
   * Wait for auth initialization to complete before showing UI.
   * This prevents race conditions where components make API calls
   * before auth state is ready.
   */
  private async waitForAuth() {
    // Wait for APP_INITIALIZER to complete
    // No need to call getUserInfo again - it's already fetched in app.config.ts
    await new Promise((resolve) => setTimeout(resolve, 150));
    console.log("✓ Auth ready before UI render");
  }
}
